<template>

    <div class="row h-100">
        <div class="col-sm-10 col-md-11 col-lg-8 my-auto mx-auto">
            <div class="row">
                <div class="col-md-6 bg-white py-5 px-5">
                    <div class="row">
                        <div class="col-12 px-5 px-md-2">

                            <h1 class="text-center mb-3">
                                <span>Register</span>
                            </h1>

                            <kt-input
                                class="my-2"
                                v-model="name"
                                label="Name"
                                type="text"
                                placeholder="Enter your name"
                            >
                                <template #prefix>
                                    <div class="input-group-text">
                                    <i class="fas fa-user"></i>
                                    </div>
                                </template>
                        
                            </kt-input>

                            <kt-input
                                class="my-3"
                                v-model="email"
                                label="Email"
                                type="email"
                                placeholder="Enter your email"
                            >
                                <template #prefix>
                                    <div class="input-group-text">
                                    <i class="fas fa-envelope"></i>
                                    </div>
                                </template>
                        
                            </kt-input>

                            <kt-input
                                class="my-3"
                                v-model="password"
                                label="Password"
                                type="password"
                                placeholder="Enter your password"
                            >
                                <template #prefix>
                                    <div class="input-group-text">
                                        <i class="fas fa-lock"></i>
                                    </div>
                                </template>
                            </kt-input>

                            <div class="text-center">
                                <button 
                                    class="btn btn-outline-primary mt-4 py-2 px-4 form-control" 
                                    @click="submit()"
                                >
                                    Register
                                </button>
                            </div>

                            <div class="text-center my-3">
                                <span class="text-muted">Already have an account? 
                                    <router-link to="/login" class="text-muted">Log in</router-link>
                                </span>
                            </div>
                        </div>
                    
                    </div>
                </div>
                <div class="col-md-6 bg-login p-0">
                    <div class="bg h-100 d-flex py-3">
                        <div class="text-center my-auto text-white w-50 mx-auto">
                            <h4>
                                <img src="/images/favicon.png" alt="7th Level Technologies" style="width: 25%; max-width: 100%; height: auto;" class="mb-3"><br />
                                Manage project time and resources with ease.
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>

import { ref } from "vue";
import { useRouter } from "vue-router";
import Api from "@/services/Api";
import Alert from "@/services/Alert";
import Cache from "@/services/Cache";
import { useAppStore } from "@/stores/AppStore"; //< TODO - move all app related / account info into a store instead of raw cache access ...
import KtInput from "@/components/UI/KtInput.vue"; 

const email = ref("");
const password = ref("");
const router = useRouter();
const appStore = useAppStore();

const submit = async () =>
{
    if (!email.value || !password.value)
    {
        Alert.notify({
            text: "Please enter your email and password"
        });

        return;
    }

    let res = await Api.login(email.value, password.value);
    
    console.debug("login", res);

    if (res.Token)
    {
        appStore.setAccount(res);

        /*
        Cache.set("bearer", res.Token);
        Cache.set("radar_user", res);
        */

        console.debug("login", res);
       
        if (res.UserId)
        {
            router.push({
                path: "/clock/list"
            });    
        }

        else
        {
            router.push({
                path: "/our-projects"
            });
        }
        
    }


}

</script>

<style>
#app.register {
    background: #212121;
}

.bg-login {
    background-image: url("/images/login_bg.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    
}

.bg-login > .bg {
    background: linear-gradient(180deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.74) 50%, rgba(0, 0, 0, 1) 100%);
}
</style>